module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "carousel"
    }
  }, [_c('v-carousel', {
    staticClass: "carousel-big-screen",
    attrs: {
      "cycle": "",
      "height": "46vh",
      "hide-delimiters": "",
      "hide-delimiter-background": "",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.items), function(item, i) {
    return _c('v-carousel-item', {
      key: i,
      attrs: {
        "src": item.src
      }
    })
  }), 1), _vm._v(" "), _c('v-carousel', {
    staticClass: "carousel-small-screen",
    attrs: {
      "cycle": "",
      "height": "25vh",
      "hide-delimiters": "",
      "hide-delimiter-background": "",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.items), function(item, i) {
    return _c('v-carousel-item', {
      key: i,
      attrs: {
        "src": item.src
      }
    })
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7aac179b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aac179b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/global/carousel/carousel.component.html
// module id = 270
// module chunks = 1